import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { parse, stringify } from 'hub-http/helpers/params';
const removeParamsFromObject = (obj, params) => {
  params.forEach(param => delete obj[param]);
};
export default function useUpdateQueryParams() {
  const history = useHistory();
  return useCallback((paramsToAdd, paramsToRemove = []) => {
    const oldParams = parse(history.location.search.substring(1));
    removeParamsFromObject(oldParams, paramsToRemove);
    history.replace({
      search: stringify(Object.assign({}, oldParams, paramsToAdd))
    });
  }, [history]);
}